import { Dialog } from '@progress/kendo-react-dialogs';
import React from 'react';
import { Button } from '@progress/kendo-react-buttons';
import { createPortal } from 'react-dom';
import { useTranslation } from '../../context/globalization/useTranslation';
import { useGlobalizationContext } from '../../context/globalization/GlobalizationContext';

export interface IGearDialogProps {
  title: string | React.JSX.Element;
  message: string | React.JSX.Element;
  onConfirm: (confirmed: boolean, closeClicked?: boolean) => void;
  confirmButtonLabel?: string;
  discardButtonLabel?: string;
}

export const useGearDialog = () => {
  const [dialogProps, setDialogProps] = React.useState<IGearDialogProps | undefined>();
  const { selectedLocale } = useGlobalizationContext();
  const { translate } = useTranslation(selectedLocale);

  const showDialog = React.useCallback((props: IGearDialogProps) => {
    setDialogProps(props);
  }, []);

  const hideDialog = React.useCallback(() => {
    setDialogProps(undefined);
  }, []);

  const DialogComponent = dialogProps
    ? createPortal(
        <Dialog
          title={dialogProps.title}
          onClose={() => {
            dialogProps.onConfirm(false, true);
            hideDialog();
          }}
          className="gearDialog"
        >
          <div className="formElementClassName">{dialogProps.message}</div>
          <div className="dialogFormButtons">
            <Button
              themeColor={'light'}
              onClick={() => {
                dialogProps.onConfirm(false);
                hideDialog();
              }}
              className="gearDialogDiscardButton"
            >
              {dialogProps.discardButtonLabel || translate('custom.common.no')}
            </Button>
            <Button
              themeColor={'inverse'}
              onClick={() => {
                dialogProps.onConfirm(true);
                hideDialog();
              }}
              className="gearDialogConfirmButton"
            >
              {dialogProps.confirmButtonLabel || translate('custom.common.yes')}
            </Button>
          </div>
        </Dialog>,
        document.body
      )
    : null;

  return {
    showDialog,
    DialogComponent
  };
};
